/// <reference types="./scaffold.d.mts" />
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import {
  activeElementId as active_element_id,
  restoreCursorPosition as restore_cursor_position,
  blurActiveElement as blur_active_element,
  subscribeFeedScroll as subscribe_feed_scroll,
  scrollTo as scroll_to,
} from "./scaffold.ffi.ts";

export {
  active_element_id,
  blur_active_element,
  restore_cursor_position,
  subscribe_feed_scroll,
};

export function scroll_to_question(question_id) {
  let node_id = "question-" + question_id;
  return scroll_to(node_id);
}

export function scroll_to_source(source_id) {
  let node_id = "row-id-" + source_id;
  return scroll_to(node_id);
}

export function scroll_to_comment(comment_id) {
  let comment_id$1 = "comment-" + comment_id;
  return scroll_to(comment_id$1);
}
